#import "../downtimeBlock/downtimeBlockInfo.gql"
#import "./workBlockInfo.gql"
#import "./workBlockInfoForSubscription.gql"

mutation UnscheduleWorkBlock($id: ID!) {
  unscheduleWorkBlock(id: $id) {
    workBlock {
      id
      workOrder {
        ...workOrderInfo
      }
    }
  }
}

mutation ScheduleWorkBlock(
  $id: ID!
  $workTimeStartsAt: ISO8601DateTime!
  $workTimeEndsAt: ISO8601DateTime!
  $workOrderId: ID!
  $lineId: ID!
  $lockedOnSchedule: Boolean!
  $teardownTimeLabel: String!
  $teardownTimeDuration: Float!
  $productionRateOverride: Float
  $performanceOverride: Float
  $efficiencyOverride: Float
  $laborOverride: Float
) {
  scheduleWorkBlock(
    id: $id
    workTimeStartsAt: $workTimeStartsAt
    workTimeEndsAt: $workTimeEndsAt
    workOrderId: $workOrderId
    lineId: $lineId
    lockedOnSchedule: $lockedOnSchedule
    teardownTimeLabel: $teardownTimeLabel
    teardownTimeDuration: $teardownTimeDuration
    productionRateOverride: $productionRateOverride
    performanceOverride: $performanceOverride
    efficiencyOverride: $efficiencyOverride
    laborOverride: $laborOverride
  ) {
    workBlock {
      ...workBlockInfo
    }
  }
}

mutation FullyScheduleWorkOrder($workBlockId: ID!) {
  fullyScheduleWorkOrder(workBlockId: $workBlockId) {
    workBlock {
      ...workBlockInfo
    }
  }
}

mutation SplitWorkBlockAcrossShifts($workBlockId: ID!) {
  splitWorkBlockAcrossShifts(workBlockId: $workBlockId) {
    workBlocks {
      startsAt
      endsAt
    }
    downtimeBlocks {
      startsAt
      endsAt
    }
  }
}

subscription OnWorkBlockCreated {
  workBlockCreated {
    workBlock {
      ...workBlockInfoForSubscription
    }
  }
}

subscription OnWorkBlockDeleted {
  workBlockDeleted {
    workBlock {
      id
    }
  }
}

subscription OnWorkBlockUpdated {
  workBlockUpdated {
    workBlock {
      ...workBlockInfoForSubscription
    }
  }
}

subscription OnWorkBlocksUpdated {
  workBlocksUpdated {
    workBlocks {
      ...workBlockInfoForSubscription
    }
  }
}
